module.exports = __webpack_public_path__ + "static/media/214x152_11 copy.74e7fc61.png";